import { Controller } from "stimulus"
import { maybeSetAppBadge, nextFrame } from "../helpers"

export default class extends Controller {
  static values = {
    count: Number,
    counts: Object,
  }

  initialize() {
    this.element.remove()
    this.updateAppBadge()
    this.updateElementBadges()
  }

  // Private

  updateAppBadge() {
    maybeSetAppBadge(this.countValue)
  }

  async updateElementBadges() {
    await nextFrame()
    for (const [name, count] of Object.entries(this.countsValue)) {
      const elements = document.querySelectorAll(`[data-notifications-name="${name}"]`)
      for (const element of elements) {
        element.setAttribute("data-notifications-count", count)
      }
    }
  }
}
